import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogOptions } from '@shared/models/client.model';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogOptions,
    private dialogRef: MatDialogRef<ConfirmComponent>,
  ) { }

  ngOnInit(): void { }

  public closeModal(status: boolean): void {
    this.dialogRef.close(status);
  }
}
